import { LitElement, html, svg } from 'lit';

export class IconCirclePlus16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Sirkel med pluss</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 5v6M5 8h6M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"></path></svg>`; }
}
if (!customElements.get('f-icon-circle-plus16', IconCirclePlus16)) {
  customElements.define('f-icon-circle-plus16', IconCirclePlus16);
}